module.exports = __webpack_public_path__ + "img/crossIcon.c732e197.svg";